"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetBaseQueryParams = void 0;

var _useGetWidgetName = require("./useGetWidgetName");

var _useGetSearchType = require("./useGetSearchType");

var _useUtmParams = require("./useUtmParams");

var _useGetIsWhitelabel = require("./useGetIsWhitelabel");

var _useGetWhitelabelName = require("./useGetWhitelabelName");

var _useGetIsPassLtAflt = require("./useGetIsPassLtAflt");

var _tracker = require("../../../utils/tracker");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useGetBaseQueryParams = function useGetBaseQueryParams() {
  var widgetName = (0, _useGetWidgetName.useGetWidgetName)();
  var searchType = (0, _useGetSearchType.useGetSearchType)();
  var utmParams = (0, _useUtmParams.useUtmParams)();
  var isWhitelabel = (0, _useGetIsWhitelabel.useGetIsWhitelabel)();
  var whitelabelName = (0, _useGetWhitelabelName.useGetWhitelabelName)();
  var isPassLtAflt = (0, _useGetIsPassLtAflt.useGetIsPassLtAflt)();

  if (!widgetName) {
    return;
  }

  var widgetNameForTracking = (0, _tracker.getWidgetNameInSnakeCase)(widgetName, searchType);
  return _objectSpread(_objectSpread(_objectSpread({}, utmParams), !isWhitelabel && (whitelabelName !== 'LT' || isPassLtAflt) ? {
    aflt: whitelabelName
  } : {}), {}, {
    utm_source: whitelabelName,
    utm_medium: 'CPA',
    utm_campaign: 'widgets',
    utm_content: widgetNameForTracking
  });
};

exports.useGetBaseQueryParams = useGetBaseQueryParams;